"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sidesheetDefaultValues = exports.NavigationAlignments = void 0;
var NavigationAlignments;
exports.NavigationAlignments = NavigationAlignments;

(function (NavigationAlignments) {
  NavigationAlignments["Leading"] = "ALIGNMENTS/LEADING";
  NavigationAlignments["Trailing"] = "ALIGNMENTS/TRAILING";
})(NavigationAlignments || (exports.NavigationAlignments = NavigationAlignments = {}));

var sidesheetDefaultValues = {
  navigationAlignment: NavigationAlignments.Leading,
  shouldUseDynamicPadding: false,
  panelWidths: {
    Mobile: '100vw',
    Tablet: '375px',
    Desktop: '480px',
    WideScreen: '560px',
    UltraWideScreen: '640px'
  }
};
exports.sidesheetDefaultValues = sidesheetDefaultValues;